import http from '../httpService';
import httpPublic from '../httpPublicService';

const manualService = {
  getManuals: params => http.get('manual', { params }),
  getManualByScreen: screen => http.get(`manual/${screen}`),
  getManualFilesByScreen: screen => http.get(`manual/${screen}/files`),
  getPublicManualFilesByScreen: screen => httpPublic.get(`manual/public/${screen}/files`),
  registerManual: ({ screen, files }) => {
    const formData = new FormData();

    formData.append('screen', screen);

    (files || []).forEach(file => {
      formData.append('files', file);
    });

    return http.post('manual', formData);
  },
  addManualFiles: (id, files) => {
    const formData = new FormData();

    (files || []).forEach(file => {
      formData.append('files', file);
    });

    return http.post(`manual/${id}/files`, formData);
  },
  updateManual: (id, data) => http.patch(`manual/${id}`, data),
  deleteManual: id => http.delete(`manual/${id}`),
  deleteManualFile: fileId => http.delete(`manual/file/${fileId}`),
};

export default manualService;
